import React from 'react';
import ReportViewer from "./base/ReportViewer";

const ListeGroupeChasseurs = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"ListeGroupeChasseurs"}/>
        </div>
    );
}
export default ListeGroupeChasseurs;